import React from "react"
import styled from "styled-components"
import { media } from "src/styles/breakpoints"
import FilterDropdown from "src/components/Form/FilterDropdown"

const ResourcesListHeader = ({ resources, onSortChange }) => {
  return (
    <Wrapper>
      <ResourceListSummary>
        {resources.length > 0
          ? `Showing:   ${resources.length} resource${
              resources.length > 1 ? "s" : ""
            }`
          : `No resources found`}
      </ResourceListSummary>
      {resources.length > 0 && (
        <ResourceListSort
          style={{ visibility: resources.length === 1 ? "hidden" : "" }}
        >
          <StyledFilterDropdown
            name={"Sort by"}
            options={[
              "Date added – newest first",
              "Date added – oldest first",
              "Name – A-Z",
              "Name – Z-A",
            ]}
            initialValue="Date added – newest first"
            onChange={onSortChange}
          />
        </ResourceListSort>
      )}
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 30px;
  font-size: 15px;
  color: #b4b3b8;
`

const ResourceListSummary = styled.div`
  white-space: pre;
`

const ResourceListSort = styled.div`
  display: none;

  ${media.tablet} {
    display: block;
    margin-top: -13px;
  }
`

const StyledFilterDropdown = styled(FilterDropdown)`
  margin-bottom: 0;
  margin-right: -25px;

  span:last-of-type {
    font-weight: inherit;
    color: ${(p) => p.theme.color.textLight};
  }

  svg {
    position: relative;
    top: -1px;
  }

  ul {
    min-width: 0;
    max-width: 100%;
  }

  &.-active {
    border-color: transparent;

    &:hover,
    &.-open {
      border-color: #cfdbdb;
    }
  }
`

export default ResourcesListHeader
